import { inject, Injectable } from '@angular/core';
import { CanMatchFn,Router } from '@angular/router';

export const AuthGuard: CanMatchFn = () => {
  const router=inject(Router)
  let user = localStorage.getItem('user')
  if (user) {
    return true;
  } else {
    router.navigate(['/auth/login']);
    return false;
  }
}
